import InventoryByDateComponent from "../components/inventory-by-date.component";

export default function InventoryByDatePage() {
  return (
    <>
      <InventoryByDateComponent />
    </>
  );
}
